export default __webpack_public_path__ + "static/media/not-filed.7cf5ac2f.svg";